<!-- eslint-disable -->
<i18n>
    {
    "en": {
        "apikey": "Api key",
        "label": "Key",
        "add_apikey": "Add api key",
        "copied_to_clipboard": "Copied to clipboard",
        "regenerate_apikey":{
            "confirmation": {
                "title": "RegenerateApikey",
                "message": "RegenerateApikey message<br>Тексты не были даны.<br>Править в <i><b>apikey-section.vue</b></i> ",
                "confirmButtonText": "Ok",
                "cancelButtonText": "Cancel"
            }
        },
        "delete_apikey":{
            "btn_caption": "Delete api key",
            "confirmation": {
                "title": "DeleteApikey",
                "message": "DeleteApikey message<br>Тексты не были даны.<br>Править в <i><b>apikey-section.vue</b></i> ",
                "confirmButtonText": "Ok",
                "cancelButtonText": "Cancel"
            }
        }
    },
    "ua": {
        "apikey": "Api key",
        "label": "Key",
        "add_apikey": "Add api key",
        "copied_to_clipboard": "Copied to clipboard",
        "regenerate_apikey":{
            "confirmation": {
                "title": "RegenerateApikey",
                "message": "RegenerateApikey message<br>Тексты не были даны.<br>Править в <i><b>apikey-section.vue</b></i> ",
                "confirmButtonText": "Ok",
                "cancelButtonText": "Cancel"
            }
        },
        "delete_apikey":{
            "btn_caption": "Delete api key",
            "confirmation": {
                "title": "DeleteApikey",
                "message": "DeleteApikey message<br>Тексты не были даны.<br>Править в <i><b>apikey-section.vue</b></i> ",
                "confirmButtonText": "Ok",
                "cancelButtonText": "Cancel"
            }
        }
    },
    "ru": {
        "apikey": "Api key",
        "label": "Key",
        "add_apikey": "Add api key",
        "copied_to_clipboard": "Copied to clipboard",
        "regenerate_apikey":{
            "confirmation": {
                "title": "RegenerateApikey",
                "message": "RegenerateApikey message<br>Тексты не были даны.<br>Править в <i><b>apikey-section.vue</b></i> ",
                "confirmButtonText": "Ok",
                "cancelButtonText": "Cancel"
            }
        },
        "delete_apikey":{
            "btn_caption": "Delete api key",
            "confirmation": {
                "title": "DeleteApikey",
                "message": "DeleteApikey message<br>Тексты не были даны.<br>Править в <i><b>apikey-section.vue</b></i> ",
                "confirmButtonText": "Ok",
                "cancelButtonText": "Cancel"
            }
        }
    }
    }
</i18n>
<!-- eslint-enable -->

<template>
  <el-col>
    <section-divider icon="el-icon-key" :text="$t('apikey')" />
    <el-row>
      <el-col v-if="service.details.api_key.value === undefined">
        <el-button
          :key="service.details.api_key.value + 'Generate'"
          type="primary"
          size="small"
          v-text="$t('add_apikey')"
          @click.once="service._handleGenerateApikey()"
        />
      </el-col>
      <el-col v-else :key="service.details.api_key.value">
        <el-row>
          <el-input
            label="$t('label')"
            :value="service.details.api_key.value"
            size="small"
            disabled
          >
            <el-button
              slot="prepend"
              icon="el-icon-paperclip"
              @click="
                handleCopyToClipboard(
                  service.details.api_key.value,
                  $t('copied_to_clipboard')
                )
              "
            />
            <el-button
              slot="append"
              icon="el-icon-refresh"
              @click="handleRegenerateApikey"
            />
          </el-input>
        </el-row>

        <el-row type="flex" justify="end" style="margin-top: 20px">
          <el-button
            type="danger"
            size="small"
            icon="el-icon-delete"
            @click="handleDeleteApikey()"
          >
            {{ $t("delete_apikey.btn_caption") }}
          </el-button>
        </el-row>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
import SectionDivider from "../SectionDivider";

export default {
  name: "apikey-section",
  components: { SectionDivider },
  props: {
    service: Object
  },
  methods: {
    handleCopyToClipboard(v, message) {
      this.$copyText(v);
      if (!message) {
        return;
      }
      this.$notify({
        type: "info",
        message: message
      });
    },
    handleRegenerateApikey() {
      this.$confirm(
        this.$t("regenerate_apikey.confirmation.message"),
        this.$t("regenerate_apikey.confirmation.title"),
        {
          confirmButtonText: this.$t(
            "regenerate_apikey.confirmation.confirmButtonText"
          ),
          cancelButtonText: this.$t(
            "regenerate_apikey.confirmation.cancelButtonText"
          ),
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.service._handleGenerateApikey();
        })
        .catch(() => {});
    },
    handleDeleteApikey() {
      this.$confirm(
        this.$t("delete_apikey.confirmation.message"),
        this.$t("delete_apikey.confirmation.title"),
        {
          confirmButtonText: this.$t(
            "delete_apikey.confirmation.confirmButtonText"
          ),
          cancelButtonText: this.$t(
            "delete_apikey.confirmation.cancelButtonText"
          ),
          type: "warning",
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.service._handleDeleteApikey();
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped lang="stylus">
.input-prepend-actions-group
    display flex
</style>
